/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clubs_Challenge_Workouts_HintInputs */

const en_us2_clubs_challenge_workouts_hint = /** @type {(inputs: Clubs_Challenge_Workouts_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Each workout finished in the app counts, up to 2 a day.`)
};

const pt_br2_clubs_challenge_workouts_hint = /** @type {(inputs: Clubs_Challenge_Workouts_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cada treino concluído no app conta, até 2 por dia.`)
};

const es_419_clubs_challenge_workouts_hint = /** @type {(inputs: Clubs_Challenge_Workouts_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cuenta cada entrenamiento terminado en la app, hasta 2 por día.`)
};

const pt_pt2_clubs_challenge_workouts_hint = /** @type {(inputs: Clubs_Challenge_Workouts_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conta cada treino concluído na app, até 2 por dia.`)
};

const fr_fr2_clubs_challenge_workouts_hint = /** @type {(inputs: Clubs_Challenge_Workouts_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chaque séance terminée dans l'appli compte, jusqu'à 2 par jour.`)
};

const de_de2_clubs_challenge_workouts_hint = /** @type {(inputs: Clubs_Challenge_Workouts_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jedes in der App beendete Training zählt, bis zu 2 pro Tag.`)
};

const it_it2_clubs_challenge_workouts_hint = /** @type {(inputs: Clubs_Challenge_Workouts_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conta ogni allenamento concluso nell'app, fino a 2 al giorno.`)
};

/**
* | output |
* | --- |
* | "Each workout finished in the app counts, up to 2 a day." |
*
* @param {Clubs_Challenge_Workouts_HintInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const clubs_challenge_workouts_hint = /** @type {((inputs?: Clubs_Challenge_Workouts_HintInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clubs_Challenge_Workouts_HintInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_clubs_challenge_workouts_hint(inputs)
	if (locale === "es-419") return es_419_clubs_challenge_workouts_hint(inputs)
	if (locale === "pt-PT") return pt_pt2_clubs_challenge_workouts_hint(inputs)
	if (locale === "fr-FR") return fr_fr2_clubs_challenge_workouts_hint(inputs)
	if (locale === "de-DE") return de_de2_clubs_challenge_workouts_hint(inputs)
	if (locale === "it-IT") return it_it2_clubs_challenge_workouts_hint(inputs)
	return en_us2_clubs_challenge_workouts_hint(inputs)
});
export { clubs_challenge_workouts_hint as "clubs.challenge_workouts_hint" }